import { UserFormFields } from "@/components/UserFormFields/UserFormFields";
import { Form } from "antd";
import type { FormInstance } from "antd";
import type { PurchaseContractFormValues } from "../type";
import { BasicContractFormFields } from "./BasicContractFormFields";
import { useInitFormValues } from "../hooks/useInitFormValues";
import { ApplicantFormFields } from "./ApplicantFormFields";
import { ContractReviewFormFields } from "./ContractReviewFormFields";

type Props = {
  form: FormInstance<PurchaseContractFormValues>;
};

export const PurchaseContractForm = (props: Props) => {
  const { form } = props;

  useInitFormValues(form);
  return (
    <Form form={form} layout="vertical">
      {/* 创建人信息 */}
      <UserFormFields />

      {/* 基本合同信息 */}
      <BasicContractFormFields />

      {/* 申请人信息 */}
      <ApplicantFormFields />

      {/* 合同审查信息 */}
      <ContractReviewFormFields />
    </Form>
  );
};
